import { IAP_CATALOG, IAP_REWARD_TYPE } from "./iap-rewards";
import type { MailReward } from "./api";

// These fields mirror the same list; never concatenate them and double grants.
export function readPurchasedIaps(cloud: unknown, sus: string | undefined): string[] {
  const saved = (cloud as { userData?: { purchasedItems?: unknown } } | null)?.userData?.purchasedItems;
  let list = saved;
  if (!Array.isArray(list)) {
    try { list = JSON.parse(sus ?? "null")?.lists; } catch { list = null; }
  }
  return Array.isArray(list) ? list.filter((id): id is string => typeof id === "string" && id.trim().length > 0) : [];
}

export function purchaseRestoration(ids: string[]) {
  const counts = new Map<string, number>();
  for (const id of ids) {
    const product = IAP_CATALOG.find((p) => p.id === id || p.aliases.includes(id));
    const canonical = product?.id ?? id;
    counts.set(canonical, (counts.get(canonical) ?? 0) + 1);
  }
  const entries = [...counts].map(([id, amount]) => {
    const product = IAP_CATALOG.find((p) => p.id === id);
    return { id, amount, issue: product ? product.unavailable : "Unknown IAP product; select a catalogue product or remove this attachment.", summary: product?.summary };
  });
  const rewards: MailReward[] = entries.flatMap(({ id, amount }) => {
    const result: MailReward[] = [];
    for (let remaining = amount; remaining > 0; remaining -= 100) {
      result.push({ rewardType: IAP_REWARD_TYPE, amount: Math.min(remaining, 100), iapProductId: id });
    }
    return result;
  });
  return { entries, rewards };
}
